export function getRandomInt(min = 1, max = 100000) 
{
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1) + min);
}

/**
 * This functions has development purposes and a default device 
 * use must not be implemented on deployment build
 */
export function getCameraConfig()
{
    // const cameraId = "6f051916d6caac6e2f9fe9189561710618d7a9980ff9937783d96f11b8e398bc"
    const cameraId = ""
    if(!cameraId) return undefined
    else return {
        videoConfig: {
            cameraId: cameraId
        }
    }
}
